import PicklistMetadata from "../../metadata/picklist/PicklistMetadata";
import picklistMetadataClassFactory from "../../metadata/PicklistMetadataClassFactory";

class Picklist {
    public picklistMetadata: PicklistMetadata = new PicklistMetadata();
    public exclusionList: string[] = [];
    public allowNoSelection: boolean;
    public bounded: boolean;
    public name: string;
    public longList: boolean;
    public searchSpecification: object | null;

    constructor(name: string) {
        let metadataClass = picklistMetadataClassFactory(name);
        // @ts-ignore
        this.picklistMetadata = new metadataClass() as PicklistMetadata;

        this.allowNoSelection = this.picklistMetadata.getAllowNoSelection();
        this.bounded = this.picklistMetadata.getBounded();
        this.name = this.picklistMetadata.getName();
        this.longList = this.picklistMetadata.getLongList();
        this.searchSpecification = this.picklistMetadata.getSearchSpecification();
    };

    getName = (): string => {
        return this.name;
    };

    getBounded = (): boolean => {
        return this.bounded;
    };

    getEnterpriseComponent = () => {
        return this.picklistMetadata.getEnterpriseComponent();
    };

    getLongList = (): boolean => {
        return this.longList;
    };

    getNoDelete = () => {
        return this.picklistMetadata.getNoDelete();
    };

    getNoUpdate = () => {
        return this.picklistMetadata.getNoUpdate();
    };

    getNoInsert = () => {
        return this.picklistMetadata.getNoInsert();
    };

    getNoMerge = () => {
        return this.picklistMetadata.getNoMerge();
    };

    getSearchSpecification = () => {
        return this.searchSpecification;
    };

    getSortSpecification = () => {
        return this.picklistMetadata.getSortSpecification();
    };

    getStatic = () => {
        return this.picklistMetadata.getStatic();
    };

    // Exclusion flags. These MUST be delegated here: PlatformSelect receives a Picklist, not the
    // metadata, and calls them defensively as `picklist.getX && picklist.getX()`. Undefined on the
    // wrapper meant the guard short-circuited and the feature silently did nothing -- which is what
    // happened to excludeCurrentRecordValue in every app that declared it.
    getExcludeCurrentRecordValue = () => {
        return this.picklistMetadata.getExcludeCurrentRecordValue
            ? this.picklistMetadata.getExcludeCurrentRecordValue()
            : false;
    };

    getTypeField = () => {
        return this.picklistMetadata.getTypeField();
    };

    getTypeValue = () => {
        return this.picklistMetadata.getTypeValue();
    };

    getVisibilityType = () => {
        return this.picklistMetadata.getVisibilityType();
    };

    getServerFilter = () => {
        return this.picklistMetadata.getServerFilter();
    };

    getServerFilterOperator = () => {
        return this.picklistMetadata.getServerFilterOperator();
    };

    getServerFilterLimit = () => {
        return this.picklistMetadata.getServerFilterLimit();
    };

    getMustMatchOption = () => {
        return this.picklistMetadata.getMustMatchOption();
    };

    getAllowNoSelectionDisplayValue = () => {
        return this.picklistMetadata.getAllowNoSelectionDisplayValue();
    };

    getAllowNoSelection = () => {
        return this.allowNoSelection;
    };

    getAllowNoSelectionValue = () => {
        return this.picklistMetadata.getAllowNoSelectionValue();;
    };

    getCompanySource = () => {
        return this.picklistMetadata.getCompanySource();
    };

    getExcludeFormFields = () => {
        return this.picklistMetadata.getExcludeFormFields();
    };

    getExcludeEnterpriseComponentAttributes = () => {
        return this.picklistMetadata.getExcludeEnterpriseComponentAttributes();
    };

    getHierarchical = () => {
        return this.picklistMetadata.getHierarchical();
    };

    getHierarchyParentField = () => {
        return this.picklistMetadata.getHierarchyParentField();
    };

    getSecondaryDisplayField = () => {
        return this.picklistMetadata.getSecondaryDisplayField();
    };

    getSecondaryDisplayLabel = () => {
        return this.picklistMetadata.getSecondaryDisplayLabel();
    };

    getExclusionList = () => {
        return this.exclusionList;
    };

    reevaluateMetadata() {
        let metadataClass = picklistMetadataClassFactory(this.name);
        // @ts-ignore
        this.picklistMetadata = new metadataClass() as PicklistMetadata;
    }

    setExclusionList = (valuesToExclude: string[]) => {
        this.exclusionList = valuesToExclude;
    };

    setSearchSpecification = (searchSpecification: object) => {
        this.searchSpecification = searchSpecification;
    };

    setAllowNoSelection = (allowNoSelection: boolean) => {
        this.allowNoSelection = allowNoSelection;
    }
}

export default Picklist;